//@flow
import * as actionTypes from './actionTypes';
import {
    submitTaskApi,getTaskApi,getVendorsPhoenixRestApi,getVendorsApi
} from '../../apiUtils/api';
import { transformDataToEditFormData } from './editFormData'
import { getReviewOutcome } from '../demeter/submitFormData'
import type { Dispatch$Type,ReducerState$Type,EditForm$Type,PostForm$Type } from '../genericFlowTypes'
import { getLookupDataApi } from '@lesofi/phoenix-sdk-js/lib/phoenixgoapi/worker'

const workflowType = 'Rhea'

export const getTaskData=(rhea:ReducerState$Type, jwt:string,taskAcceptedInfoId: number)=>{
    return (dispatch:Dispatch$Type) => getTaskApi(jwt,workflowType,taskAcceptedInfoId.toString())
    .then((res)=>res.json()).then((data)=>{
        const error = (data.error:any|null)
        if (error){
            dispatch({type: actionTypes.RHEA_EDIT_VERIFY_FORM_DATA_ERROR,error: error});
        }else {
            const formData = transformDataToEditFormData(data,rhea)
            dispatch({
                type: actionTypes.RHEA_EDIT_VERIFY_FORM_DATA_SUCCESS, 
                formData: formData,reviewQuestions: data['reviewQuestions'] });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.RHEA_EDIT_VERIFY_FORM_DATA_ERROR, error: err});
    })
}

export const invoiceSubmissionCompleted = () => {
    return { type: actionTypes.RHEA_INV_SUBMITTED_COMPLETED };
}

export const invoiceSubmission = (jwt:any,taskAcceptedInfoId:number,rheaResultset:any,rhea:ReducerState$Type)=>{
    let payload:PostForm$Type={
        taskAcceptedInfoId:taskAcceptedInfoId
    };

    if (rheaResultset.isInvalidDoc){
        payload.isInvalidDoc=true;
    }else {
        payload.vendorName=rheaResultset.vendorName;
        payload.supplierId=rheaResultset.supplierId;//leave it here but retired
        payload.internalId=rheaResultset.internalId; //New Field
        payload.invNo=rheaResultset.invNo;
        payload.invDate=rheaResultset.invDate;
        payload.poNo=rheaResultset.poNo;
        payload.deptNo=rheaResultset.deptNo;
        payload.requestor=rheaResultset.requestor;
        payload.modifier=rheaResultset.modifier;//New Field
        payload.account=rheaResultset.account;//New Field
        payload.requestorId=rheaResultset.requestorId;//New Field
        payload.glString=rheaResultset.glString;//leave it here but retired
        payload.tax=rheaResultset.tax;
        payload.additional=rheaResultset.additional;
        payload.total=rheaResultset.total;
        payload.isInvalidDoc=rheaResultset.isInvalidDoc?rheaResultset.isInvalidDoc:false;
        payload.isOverrideTotal=rheaResultset.isOverrideTotal?rheaResultset.isOverrideTotal:false;
        payload.isOverrideVendorName=rheaResultset.isOverrideVendorName?rheaResultset.isOverrideVendorName:false;
        payload.isGlStringNotFound=rheaResultset.isGlStringNotFound?rheaResultset.isGlStringNotFound:false;
    }

    if (rhea.reviewQuestions && rhea.reviewQuestions.length > 0){
        payload.reviewOutcome=getReviewOutcome(rheaResultset,rhea.reviewQuestions)
    }
    
    return (dispatch:Dispatch$Type) => submitTaskApi(jwt,payload).then((res)=>res.json()).then((data) =>{
        if (data['error']){
            dispatch({type: actionTypes.RHEA_INV_SUBMIT_ERROR, error: data.error});
        }else {
            dispatch({type: actionTypes.RHEA_INV_SUBMIT_SUCCESS});
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.RHEA_INV_SUBMIT_ERROR, error: err});
    })
}

export const updateFormError=(error:any|null)=>{
    return { type: actionTypes.RHEA_UPDATE_FORM_ERROR, formError: error }
}

export const populateVendorsList=(jwt:any)=>{
    return (dispatch:Dispatch$Type) => getLookupDataApi(workflowType,"vendors")
    .then((resp) => resp.json()).then(data =>{
        
        dispatch({type: actionTypes.REFRESH_RHEA_VENDORS_SUCCESS, vendors: data });
        
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.REFRESH_RHEA_VENDORS_ERROR, error: err});
    })
}

export const populateRequestorsList=(jwt:any)=>{
    return (dispatch:Dispatch$Type) => getVendorsPhoenixRestApi(jwt,'rhea_requestors')
    .then(resp => resp.json()).then(data =>{

        dispatch({type: actionTypes.REFRESH_RHEA_REQUESTORS_SUCCESS, requestors: data });
        
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.REFRESH_RHEA_REQUESTORS_ERROR, error: err});
    })
}

export const refreshCacheValue=(key:any, value:any)=>{
    return { type: actionTypes.REFRESH_RHEA_CACHE_VALUE, anyKey: key, anyValue: value }
}


// WEBPACK FOOTER //
// ./src/redux/rhea/actions.js